var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComputer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M28 3H4a1 1 0 0 0-1 1v12h20v2H3v5a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-5h-2v-2h2V4a1 1 0 0 0-1-1M1 4v19a3 3 0 0 0 3 3h11v4H7a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-8v-4h11a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3m15 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
  clipRule: "evenodd"
})));
export default SvgComputer;